function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { find, isNaN, isString } from 'lodash';
import queryString from 'query-string';
import isUrl from 'is-url';

/**
 * 是否为空值，包括 null、undefined、'' 和 NaN
 */
export function isNullValue(value) {
  return value === null || value === undefined || value === '' || isNaN(value);
}
/**
 * 找到任意属性 key 对应的值和目标值相等的数组对象
 */
export function findBy(array, key, value) {
  return find(array, function (item) {
    return item && item[key] === value;
  }) || {};
}

/**
 * 找到属性 value 对应的值和目标值相等的数组对象
 */
export function findByValue(array, value) {
  return find(array, function (item) {
    return item && item.value === value;
  }) || {};
}
/**
 * 页面跳转，不同于 history.push() 仅支持同一标签页下跳转，directTo 常用于新开标签页跳转
 * @param {string}  url 跳转链接，支持相对链接和绝对链接
 * @param {boolean} blank 是否新开标签页
 */
export function directTo(url) {
  var blank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  // 路由前缀
  var routerBase = window.routerBase;
  // 约定 window.displayMode 为 embed 时为 iframe 嵌入模式，此时 directTo 会在当前页打开
  // 并且跳转时自动传递 displayMode 参数，以保证后续页面下 directTo 也在当前页打开
  var displayMode = window.displayMode;
  var newUrl =
  // 如果部署在根路径，或者是完整 URL，则使用原始值
  !routerBase || routerBase === '/' || isUrl(url) ? url : "".concat(routerBase).concat(url);
  if (blank && displayMode !== 'embed') {
    // 在新的标签页中打开
    var blankWindow = window.open('about:blank');
    if (blankWindow) {
      blankWindow.location.href = newUrl;
    } else {
      // 兜底逻辑，在当前标签页打开
      window.location.href = newUrl;
    }
  } else {
    // 在当前标签页打开
    window.location.href = queryString.stringifyUrl({
      url: newUrl,
      query: {
        displayMode: displayMode
      }
    });
  }
}

/**
 * 文件下载，支持下载格式为 Blob、File、ArrayBuffer 和 string 的文件
 * @param {Blob | File | ArrayBuffer | string} content 下载内容
 * @param {string} fileName 下载后保存的文件名
 * @param {BlobPropertyBag} options BlobPropertyBag 字典，可参考 https://developer.mozilla.org/zh-CN/docs/Web/API/Blob/Blob#%E5%8F%82%E6%95%B0
 */
export function downloadFile(content, fileName, options) {
  var blob = new Blob([content], _objectSpread(_objectSpread({}, isString(content) ? {
    type: 'text/plain;charset=utf-8'
  } : {}), options));
  var blobUrl = window.URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.download = fileName;
  a.href = blobUrl;
  a.click();
  a.remove();
}

/**
 * 接收一个 value 转换为数组
 * @param {any | any[]}  value
 */
export function toArray(value) {
  if (value === undefined || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}